import { useIntl } from 'react-intl';
import { Row, Col } from 'reactstrap';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';
import InputNumber from 'src/componentes/input-number';
import DatePicker from 'src/componentes/date-picker';
import EstagioLookup from 'src/lookups/DetalhamentoFinanceiroEstagioLookup';
import AcaoLookup from 'src/lookups/acao';

const Geral = ({ model, projetoId }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const modelEstagio = model.getModel('estagio');
  const modelData = model.getModel('data');
  const modelValor = model.getModel('valor');
  const modelAcao = model.getModel('acao');

  return (
    <>
      {projetoId && (
        <Row>
          <Col md={6}>
            <AcaoLookup
              model={{
                label: capitalizeFirstLetter(resources.acao),
                value: modelAcao.value,
                requestChange: modelAcao.requestChange,
                errors: modelAcao.errors,
              }}
              data={{ itemId: projetoId, tipoItemId: 4 }}
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col md={6}>
          <EstagioLookup
            clearable
            model={{
              label: intl.formatMessage({ id: 'estagio' }),
              value: modelEstagio.value,
              requestChange: modelEstagio.requestChange,
              errors: modelEstagio.errors,
            }}
            required
          />
        </Col>
      </Row>
      <Row>
        <Col md={2}>
          <DatePicker
            timeFormat={false}
            autoFormatDate={true}
            model={{
              label: intl.formatMessage({ id: 'data' }),
              value: modelData?.value,
              requestChange: modelData.requestChange,
              errors: modelData.errors,
            }}
            required
          />
        </Col>
        <Col md={3}>
          <InputNumber
            precision={2}
            model={{
              value: modelValor.value,
              label: intl.formatMessage({ id: 'valor' }),
              requestChange: modelValor.requestChange,
              errors: modelValor.errors,
            }}
            required
          />
        </Col>
      </Row>
    </>
  );
};

export default Geral;
